module.exports = __webpack_public_path__ + "img/K_candy.0af7c051.png";